import React, {useEffect, useRef, useState} from "react";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import Dropdown from "../../../primer/Dropdown";
import {Col, Row, Spinner} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import {toast} from "react-toastify";
import {useSelector} from "react-redux";
import Alert from "react-bootstrap/Alert";
import BetterCheckBox from "../../../common/BetterCheckBox";
import Input from "../../../common/Input";
import {isEmpty} from "../../../../_helpers/commonFunctions";
import {constructInstitutesOptions} from "./constants";

const BankConnectModal = ({show, setShow, successfulCallback}) => {
    /*
        Modal have 3 steps:
        - 1st step select bank institute and press "Διασύνδεση" button
        - 2nd step wait for the user to complete/cancel the agreement
        - 3rd step (on successful completion of the agreement) make user select bank accounts he wants to hook
     */
    const company = useSelector((state) => state.COMPANY_DATA.company);

    const [institutes, setInstitutes] = useState([]);
    const [selectedInstitute, setSelectedInstitute] = useState("");
    const [isConnecting, setIsConnecting] = useState(false);
    const [isConnectingViva, setIsConnectingViva] = useState(false);

    const [banksArr, setBanksArr] = useState([]);
    const [selectBanks, setSelectBanks] = useState(false);

    const [loadingLimit, setLoadingLimit] = useState(false);
    const [currentCount, setCurrentCount] = useState(0);
    const [currentLimit, setCurrentLimit] = useState(0);
    const [alreadyConnectedIBANs, setAlreadyConnectedIBANs] = useState([]);

    const [specialUsername, setSpecialUsername] = useState(""); // For VIVA as Client ID
    const [specialPassword, setSpecialPassword] = useState(""); // For VIVA as Client Secret

    const [specialUsername2, setSpecialUsername2] = useState(""); // For VIVA as Client ID for Bank Transactions
    const [specialPassword2, setSpecialPassword2] = useState(""); // For VIVA as Client Secret for Bank Transactions

    const agreementRef = useRef("");
    const monitorPopupRef = useRef(0);
    const popupWindowRef = useRef(null);

    const permissionsData = JSON.parse(localStorage.getItem("permissions"));

    const instituteOptions = constructInstitutesOptions(institutes, permissionsData);

    const isViva = selectedInstitute === "PRXBGRAA";

    useEffect(() => {
        fetchInstitutes();
    }, []);

    useEffect(() => {
        if (!show) {
            setSpecialUsername("");
            setSpecialPassword("");
            setSelectedInstitute("");
        } else {
            closeIfNoLimit()
        }
    }, [show])

    const closeIfNoLimit = () => {
        axios.get(`${process.env.REACT_APP_API_URL2}/accounting/banking-limit`, {
            headers: { 'Content-Type': 'application/json' },
            params: {
                company: company.id,
            }
        }).then((res) => {
            /*
            Close only if he doesn't have a specified limit. Reaching limit doesn't always mean that
            he is going to add a new account as he can "refresh" an existing connection
             */
            if ([0, -1].includes(res.data.limit)) {
                setShow(false);
                toast.warning("Δεν έχετε την δυνατότητα να διασυνδέσετε νέους λογαριασμούς.");
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    const fetchInstitutes = () => {
        axios.get(`${process.env.REACT_APP_API_URL2}/accounting/banking-institutes`, {
            headers: { 'Content-Type': 'application/json' },
        }).then((res) => {
            if (res.data.status === "200") {
                setInstitutes([
                    {id: "PRXBGRAA", name: "Viva Bank"},
                    ...res.data.data,
                ]);
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    const handleConnect = async () => {
        try {
            if (isViva) {
                if (isEmpty(specialUsername) || isEmpty(specialPassword) || isEmpty(specialUsername2) || isEmpty(specialPassword2)) {
                    return toast.error("Παρακαλώ συμπληρώστε Client ID και Client Secret.");
                }
                setIsConnectingViva(true);
                const response = await axios.post(`${process.env.REACT_APP_API_URL2}/accounting/banking-connect`, {
                    company: company.id,
                    selectedInstitute: selectedInstitute,
                    specialUsername: String(specialUsername).trim(),
                    specialPassword: String(specialPassword).trim(),

                    specialUsername2: String(specialUsername2).trim(),
                    specialPassword2: String(specialPassword2).trim(),
                });
                if (response.data.status === "200") {
                    const resData = response.data.data;
                    agreementRef.current = resData._id;
                    generallyHandleAgreement();
                } else {
                    setIsConnectingViva(false);
                    return toast.error(response.data.message);
                }
                setIsConnectingViva(false);
            } else {
                setIsConnecting(true);
                const response = await axios.post(`${process.env.REACT_APP_API_URL2}/accounting/banking-connect`, {
                    company: company.id,
                    selectedInstitute: selectedInstitute,
                    redirectBaseURL: process.env.REACT_APP_API_URL2,
                });
                if (response.data.status === "200") {
                    const resData = response.data.data;
                    agreementRef.current = response.data.agreementId;

                    // Returns object with key "link" that we need to open on new tab
                    const popWind = window.open(resData.link, "_blank", `toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=800,height=600`);
                    if (popWind) { // Track window closure
                        monitorPopupRef.current = setInterval(() => {
                            try {
                                if (popWind.closed) generallyHandleAgreement();
                            } catch (_) {}
                        }, 1000);
                        popupWindowRef.current = popWind;
                    }
                } else {
                    setIsConnecting(false);
                    return toast.error(response.data.message);
                }
            }
        } catch (e) {
            setIsConnecting(false);
            console.log(e);
            toast.error("Σφάλμα κατά την εκτέλεση διαδικασίας.");
        }
    }

    const generallyHandleAgreement = async (forceCancel = false) => {
        let proceedClosure = forceCancel;

        if (!proceedClosure) {
            try {
                const agreementResponse = await axios.get(`${process.env.REACT_APP_API_URL2}/accounting/agreement`, {
                    params: {
                        company: company.id,
                        agreementId: agreementRef.current,
                    }
                });
                if (agreementResponse.data.status === "200") {
                    const resData = agreementResponse.data.data;
                    if (resData.requisitionSuccess === true) {
                        proceedClosure = true;
                        setBanksArr(resData.accounts);
                        setSelectBanks(true);
                        loadLimit();
                    }
                }
            } catch (axiosError) {
                console.log(axiosError);
                toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            }
        }
        if (proceedClosure) {
            clearInterval(monitorPopupRef.current);
            monitorPopupRef.current = 0;
            setIsConnecting(false);
            if (popupWindowRef.current) {
                if (!popupWindowRef.current.closed) popupWindowRef.current.close();
                popupWindowRef.current = null;
            }
        }
    }

    const handleSaveHookedBanks = () => {
        if (loadingLimit) return toast.warning("Παρακαλώ δοκιμάστε αργότερα.");

        axios.post(`${process.env.REACT_APP_API_URL2}/accounting/agreement-accounts`, {
            company: company.id,
            agreementId: agreementRef.current,
            accounts: banksArr,
        }, {
            headers: {"Content-Type": "application/json"}
        }).then((res) => {
            if (res.data.status === "200") {
                agreementRef.current = "";
                setSelectBanks(false);
                setBanksArr([]);
                setShow(false);
                toast.success("Επιτυχής διασύνδεση.");
                successfulCallback();
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const loadLimit = () => {
        try {
            setLoadingLimit(true);
            axios.get(`${process.env.REACT_APP_API_URL2}/accounting/banking-limit`, {
                headers: { 'Content-Type': 'application/json' },
                params: {
                    company: company.id,
                }
            }).then((res) => {
                if (res.data.status === "200" || res.data.status === "400") {
                    setCurrentCount(res.data.current);
                    setCurrentLimit(res.data.limit);
                    setAlreadyConnectedIBANs(res.data.ibans);
                } else {
                    agreementRef.current = "";
                    setSelectBanks(false);
                    setBanksArr([]);
                    setShow(false);
                    toast.error(res.data.message);
                }
                setLoadingLimit(false);
            }).catch((err) => {
                console.log(err);
                setLoadingLimit(false);
            })
        } catch (error) {
            console.log(error);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        }
    }

    const hideCloseButton = isConnecting || isConnectingViva || selectBanks;
    const currentNewCount = () => {
        let defCount = currentCount;
        for (const bank of banksArr) {
            if (bank.hooked === true && !alreadyConnectedIBANs.includes(bank.iban)) defCount++;
        }
        return defCount;
    }

    return (
        <React.Fragment>
            <Modal show={show} backdrop={"static"} onHide={() => setShow(false)}>
                <Modal.Header closeButton={!hideCloseButton}>
                    <Modal.Title>Διασύνδεση τραπεζικού ιδρύματος</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectBanks ? (
                        <React.Fragment>
                            <div className={"mb-1"}>
                                Παρακαλώ επιλέξτε τους τραπεζικούς λογαριασμούς που επιθυμείτε να διασυνδέσετε:
                            </div>
                            {banksArr.map((bank, idx) => (
                                <div key={`bank-${idx}`}>
                                    <BetterCheckBox
                                        text={bank.iban}
                                        checked={bank.hooked}
                                        className={"mt-1 mb-1"}
                                        onChange={(e) => {
                                            const cloned = structuredClone(banksArr);
                                            cloned[idx].hooked = e.target.checked;
                                            setBanksArr(cloned);
                                        }}
                                    />
                                </div>
                            ))}
                            <div>
                                <strong>Πλήθος διασυνδεδεμένων λογαριασμών / Όριο:</strong> {currentNewCount()} / {currentLimit}
                            </div>
                            <div style={{textAlign: "center"}} className={"mt-2"}>
                                <Button size={"sm"} onClick={() => handleSaveHookedBanks()} disabled={
                                    banksArr.every((el) => el.hooked !== true)
                                    ||
                                    currentNewCount() > currentLimit
                                }>Ολοκλήρωση διασύνδεσης</Button>
                            </div>
                        </React.Fragment>
                    ) : isConnecting ? (
                        <React.Fragment>
                            <div style={{textAlign: "center"}}>
                                Παρακαλώ συνεχίσετε την διασύνδεση στο παράθυρο που εμφανίστηκε. Όταν ολοκληρώσετε την διασύνδεση,
                                θα εμφανιστούν εδώ οι λογαριασμοί και θα πρέπει να επιλέξετε όποιους επιθυμείτε.
                                <div>
                                    <Button size={"sm"} variant={"outline-danger"} onClick={() => generallyHandleAgreement(true)} className={"mt-3"}>Ακύρωση διασύνδεσης</Button>
                                </div>
                            </div>
                        </React.Fragment>
                    ) : isConnectingViva ? (
                        <React.Fragment>
                            <div style={{textAlign: "center"}}>
                                Γίνεται διασύνδεση παρακαλώ περιμένετε... <Spinner className={"ml-2"} size={"sm"} animation={"border"} variant={"dark"}/>
                            </div>
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            <Row>
                                <Col md={12}>
                                    <Dropdown
                                        className={"mb-2"}
                                        name={"selectedInstitute"}
                                        label={"Τραπεζικό Ίδρυμα"}
                                        options={instituteOptions}
                                        defaultValue={instituteOptions.find((el) => el.value === selectedInstitute)}
                                        onChange={(e) => setSelectedInstitute(e.value)}
                                    />
                                    {selectedInstitute && (
                                        <React.Fragment>
                                            {isViva ? (
                                                <Alert variant={"secondary"} className={"mb-1"}>
                                                    <strong>Πεδίο 1:</strong> Στοιχεία από το Bank Transactions. Συνδεθείτε στον λογαριασμό σας στην VIVA και κατευθυνθείτε στις Ρυθμίσεις → Πρόσβαση API.
                                                    Δημιουργήστε ένα διαπιστευτήριο στην ενότητα "Διαπιστευτήρια συναλλαγών λογαριασμού" και αποθηκεύστε το Client ID και το Client Secret σε ασφαλές περιβάλλον
                                                    για να τα έχετε πρόχειρα.
                                                    <Input
                                                        className={"mt-1"}
                                                        name={"specialUsername"}
                                                        label={"Client ID"}
                                                        required={true}
                                                        value={specialUsername}
                                                        autoComplete={"off"}
                                                        onChange={(e) => setSpecialUsername(e.target.value)}
                                                    />
                                                    <Input
                                                        className={"mt-1"}
                                                        name={"specialPassword"}
                                                        label={"Client Secret"}
                                                        required={true}
                                                        value={specialPassword}
                                                        autoComplete={"off"}
                                                        onChange={(e) => setSpecialPassword(e.target.value)}
                                                    />
                                                    <hr/>
                                                    <strong>Πεδίο 2:</strong> Στοιχεία ειδικά για τις συναλλαγές. Επικοινωνήστε με την υποστήριξη της VIVA έτσι ώστε να σας δώσουν νέο Client ID και Client Secret
                                                    συγκεκριμμένα για την <u>δυνατότητα άντλησης συναλλαγών</u> από τους λογαριασμούς σας.
                                                    <Input
                                                        className={"mt-1"}
                                                        name={"specialUsername2"}
                                                        label={"Client ID"}
                                                        required={true}
                                                        value={specialUsername2}
                                                        autoComplete={"off"}
                                                        onChange={(e) => setSpecialUsername2(e.target.value)}
                                                    />
                                                    <Input
                                                        className={"mt-1"}
                                                        name={"specialPassword2"}
                                                        label={"Client Secret"}
                                                        required={true}
                                                        value={specialPassword2}
                                                        autoComplete={"off"}
                                                        onChange={(e) => setSpecialPassword2(e.target.value)}
                                                    />
                                                </Alert>
                                            ) : (
                                                <Alert variant={"secondary"} className={"mb-1"}>
                                                    Παρακαλώ επιλέξτε τραπεζικό ίδρυμα που επιθυμείτε να διασυνδεθείτε.
                                                    Στο λογισμικό θα δωθεί <u>ΜΌΝΟ</u> η άδεια άντλησης συναλλαγών και όχι εκτέλεσης ή επεξεργασίας τους.
                                                    Η διασύνδεση γίνεται με την βοήθεια του ασφαλούς περιβάλλοντος GOCARDLESS,
                                                    όπου θα κατευθυνθείτε αμέσως αφού επιλέξετε τραπεζικό ίδρυμα και πατήσετε το κουμπί "Διασύνδεση".
                                                    Σε επόμενο βήμα θα κατευθυνθείτε στο ασφαλές περιβάλλον του τραπεζικού σας ιδρύματος,
                                                    όπου θα χρειαστεί να συνδεθείτε με τους κωδικούς Web Banking σας ώστε να παραχωρήσετε τις κατάλληλες άδειες.<br/>
                                                    <strong>Προσοχή: </strong> Σε περίπτωση διασύνδεσης ήδη διασυνδεδεμένου τραπεζικού ιδρύματος,
                                                    γίνεται αυτόματη ακύρωση της προηγούμενης διασύνδεσης με αποτέλεσμα να πρέπει να επαναεπιλέξτε τους λογαριασμούς που τυχόν είχατε διασυνδέσει στο παρελθόν.
                                                </Alert>
                                            )}
                                        </React.Fragment>
                                    )}
                                </Col>
                            </Row>
                            {selectedInstitute && (
                                <React.Fragment>
                                    <Row className={"mt-1"}>
                                        <Col md={12}>
                                            <Button size={"sm"} onClick={() => handleConnect()} style={{width: "100%"}} disabled={isConnecting}>Διασύνδεση</Button>
                                        </Col>
                                    </Row>
                                </React.Fragment>
                            )}
                        </React.Fragment>
                    )}
                </Modal.Body>
            </Modal>
        </React.Fragment>
    )
}

export default BankConnectModal;
